import { useState } from "react";
import { fetchData } from "../helper/api.interceptor";
import "./Dashbord.css";
import Swal from "sweetalert2";
import PositionSelector from "./PositionSelector";

const AddOpeningModal = ({ show, onClose, onSaved }) => {
    const [location, setLocation] = useState("");
    const [selected, setSelected] = useState([]);
    const [submitting, setSubmitting] = useState(false);

    if (!show) return null;

    const handleSubmit = async () => {
        if (!location.trim()) {
            alert("Please enter location");
            return;
        }
        if (!selected.length) {
            alert("Please select at least one position");
            return;
        }

        const body = {
            location: location.trim(),
            posts: selected
        };

        try {
            setSubmitting(true);
            console.log("Posting body:", body);

            const res = await fetchData.post("/api/createOpening", body);

            if (res?.error) {
                Swal.fire({
                    title: "Duplicate Entry",
                    text: res.error,
                    icon: "warning",
                    confirmButtonText: "OK"
                });
                return;
            }

            if (res && (res.success === undefined || res.success === true)) {
                if (typeof onSaved === "function") {
                    try { onSaved(); } catch (e) { console.warn("onSaved callback threw:", e); }
                }
                if (typeof onClose === "function") {
                    try { onClose(); } catch (e) { console.warn("onClose callback threw:", e); }
                }

                Swal.fire({
                    title: "Success!",
                    text: "Opening added successfully.",
                    icon: "success",
                    confirmButtonText: "OK"
                }).then(() => {
                    window.location.reload();
                });
            } else {
                Swal.fire("Error", res?.message || "Failed to create opening", "error");
            }
        } catch (err) {
            console.error("Failed to create opening:", err);
            Swal.fire("Error", "Failed to create opening. See console for details.", "error");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="aom-overlay">
            <div className="aom-modal">
                <h4 className="aom-title">Add New Job Opening</h4>

                <div className="mb-3">
                    <label className="form-label fw-semibold">Location</label>
                    <input
                        className="form-control"
                        value={location}
                        onChange={(e) => setLocation(e.target.value)}
                        placeholder="Enter location name (e.g. Mumbai)"
                    />
                </div>

                <div className="mb-3">
                    <label className="form-label fw-semibold">Positions</label>
                    <PositionSelector selected={selected} setSelected={setSelected} />
                </div>

                <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
                    <button className="btn btn-light" onClick={onClose} disabled={submitting}>Cancel</button>
                    <button className="btn btn-primary" onClick={handleSubmit} disabled={submitting}>
                        {submitting ? "Saving..." : "Add"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AddOpeningModal;